<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="点名称">
              <a-input placeholder="请输入点名称" v-debounce="searchQuery" v-model="queryParam.pointName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="点号">
              <a-input placeholder="请输入点号" v-debounce="searchQuery" v-model="queryParam.pointCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="5">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search" type="primary"
                >查询</a-button
              >
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('alert_rule')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="enable" slot-scope="text, record">
          <a-switch
            :checked="record.enable"
            @change="handleEnable(record.id, !record.enable ? 1 : 0)"
            checked-children="启用"
            un-checked-children="禁用"
          />
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span style="font-size: 12px; font-style: italic" v-if="!text">无图片</span>
          <img
            :preview="record.id"
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width: 80px; font-size: 12px; font-style: italic"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px; font-style: italic" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <alert-rule-modal @ok="modalFormOk" ref="modalForm"></alert-rule-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import AlertRuleModal from './modules/AlertRuleModal'
import { filterMultiDictText, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import { putAction, getAction } from '@/api/manage'

export default {
  name: 'AlertRuleList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    AlertRuleModal
  },
  data() {
    return {
      description: 'alert_rule管理页面',
      isorter: {
        column: 'pointName',
        order: 'asc'
      },
      // 表头
      columns: [
        {
          title: '规则类型',
          align: 'center',
          dataIndex: 'ruleType_dictText'
        },

        {
          title: '测点名称',
          align: 'center',
          dataIndex: 'pointName',
          sorter: true
        },
        {
          title: '高3',
          align: 'right',
          dataIndex: 'high3'
        },
        {
          title: '高2',
          align: 'right',
          dataIndex: 'high2'
        },
        {
          title: '高1',
          align: 'right',
          dataIndex: 'high1'
        },

        {
          title: '低1',
          align: 'right',
          dataIndex: 'low1'
        },
        {
          title: '低2',
          align: 'right',
          dataIndex: 'low2'
        },
        {
          title: '低3',
          align: 'right',
          dataIndex: 'low3'
        },
        {
          title: '状态量',
          align: 'center',
          dataIndex: 'switchStatus_dictText',
          customRender: (text, record) => {
            return record.pointType == 'BOOL' ? text : '-'
          }
        },
        {
          title: '告警值',
          align: 'center',
          dataIndex: 'digitalValues',
          customRender: (text, record) => {
            return record.pointType == 'int' ? text : '-'
          }
        },
        {
          title: '告警通知',
          align: 'center',
          dataIndex: 'notifications',
          customRender: (text, record, index) => {
            return text.map(x => x.name).join(', ')
          },
          sorter: true
        },
        {
          title: '告警级别',
          align: 'center',
          dataIndex: 'alertLevel_dictText',
          customRender: (text, record, index) => {
            if (record.pointType.toLowerCase() !== 'float32')
              switch (record.alertLevel) {
                case '1':
                  return <a-tag color="magenta">{{ text }}</a-tag>
                case '2':
                  return <a-tag color="red">{{ text }}</a-tag>
                case '3':
                  return <a-tag color="gold">{{ text }}</a-tag>
              }
          }
        },
        {
          title: '启用状态',
          align: 'center',
          dataIndex: 'enable',
          scopedSlots: { customRender: 'enable' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],

      url: {
        list: '/rule/alertRule/list',
        delete: '/rule/alertRule/delete',
        deleteBatch: '/rule/alertRule/deleteBatch',
        exportXlsUrl: '/rule/alertRule/exportXls',
        importExcelUrl: 'rule/alertRule/importExcel',
        enableRule: 'rule/alertRule/enable'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'ruleType', text: '规则类型', dictCode: 'rule_type' })
      fieldList.push({ type: 'string', value: 'pointName', text: '测点名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'timespan', text: '回查时间', dictCode: 'timespan' })
      fieldList.push({ type: 'string', value: 'duration', text: '持续时间', dictCode: 'duration' })
      fieldList.push({ type: 'string', value: 'period', text: '检查周期', dictCode: 'period' })
      fieldList.push({ type: 'string', value: 'notifications', text: '告警通知', dictCode: '' })
      fieldList.push({ type: 'string', value: 'alertLevel', text: '告警级别', dictCode: 'alert_level' })
      fieldList.push({ type: 'int', value: 'enable', text: '启用状态', dictCode: '' })
      fieldList.push({ type: 'int', value: 'tenantId', text: '租户id', dictCode: '' })
      fieldList.push({ type: 'string', value: 'orgId', text: '公司id', dictCode: '' })
      fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
      this.superFieldList = fieldList
    },

    handleEnable: function(id, enable) {
      let that = this
      putAction(this.url.enableRule, { id: id, enable: enable })
        .then(res => {
          if (res.success) {
            that.$message.success(res.message)
            that.$emit('ok')
            this.loadData()
          } else {
            that.$message.warning(res.message)
          }
        })
        .finally(() => {
          that.confirmLoading = false
        })
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
